import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { useLazyQuery } from "@apollo/react-hooks";
import { useHistory } from "react-router-dom";
import gql from "graphql-tag";

import { useAlert } from "../components/Alert";
import Grid from "../components/Grid";
import TabView from "../components/TabView";
import LoadingModal from "../components/LoadingModal";
import GeneralInquiryTable from "./components/GeneralInquiryTable";
import GlobalQueryTable from "./components/GlobalQueryTable";
import SaleObjTable from "./SaleObjTable";
import BidWinningTable from "./components/BidWinningTable";

const GET_USER = gql`
  query user($id: Int) {
    user(id: $id) {
      id
      assignmentCount
    }
  }
`;

export default function SaleObj() {
  const Alert = useAlert();
  const history = useHistory();
  const [newData, setNewData] = useState({
    tabViewData: ["一般查詢", "區域查詢", "熱門排行榜", "總表"],
    select: 0,
  });

  function changeDataListener(key, v) {}
  function changeData(key, v, rerender = false) {
    if (rerender) setNewData((prev) => ({ ...prev, [key]: v }));
    else setNewData((prev) => Object.assign(prev, { [key]: v }));
    if (typeof changeDataListener === "function") changeDataListener(key, v);
  }

  const [getUser, { loading }] = useLazyQuery(GET_USER, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ user }) {
      if (user) {
        return Alert.alert(
          "",
          `你目前有${user.assignmentCount}項代辦事項，是否前往查看？`,
          [
            {
              text: "確定",
              onPress: () => {
                history.replace("/console/home");
              },
              type: "ok",
            },
            { text: "取消", type: "cancel" },
          ]
        );
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });
  useEffect(() => {
    if (!!localStorage.getItem("@fullhouseFirst")) {
      getUser({
        variables: {
          id: localStorage.getItem("@fullhouseUserId")
            ? Number(localStorage.getItem("@fullhouseUserId"))
            : null,
        },
      });
    }
    localStorage.removeItem("@fullhouseFirst");
  }, [localStorage.getItem("@fullhouseFirst")]);
  if (false) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <Grid>
        <LoadingModal loading={false} />
        <TabView
          scrollable
          paper
          tabs={newData.tabViewData}
          index={newData.select}
          onChange={(e) => changeData("select", e, true)}
        >
          <GeneralInquiryTable />
          <GlobalQueryTable />
          <SaleObjTable />
          <BidWinningTable />
        </TabView>
      </Grid>
    );
  }
}
